import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useAuth } from '@hooks/useAuth';
import apiClient from '@services/apiClient';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export interface PushNotificationTypes {
	payment_received: boolean;
	payment_sent: boolean;
	message_received: boolean;
}

export interface PushNotificationSettings {
	types: PushNotificationTypes;
}

export const usePushNotification = () => {
	const { session } = useAuth();

	return useQuery({
		queryKey: ['push-settings'],
		queryFn: async (): Promise<PushNotificationSettings> => {
			const response =
				await apiClient.get<PushNotificationSettings>('/users/push-settings');
			return response.data;
		},
		enabled: !!session?.tokenized,
		refetchOnWindowFocus: false,
	});
};

export const useSetPushNotification = () => {
	const queryClient = useQueryClient();
	const { t } = useTranslation('', { keyPrefix: 'pushNotifications' });

	return useMutation({
		mutationFn: (settings: PushNotificationSettings) =>
			apiClient.put('/users/push-settings', settings),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['push-settings'] });
			toastSuccess(t('updateSuccess'));
		},
		onError: () => {
			toastError(t('updateError'));
		},
	});
};
